'use strict';

var AppointmentModalBaseCtrl = require('./AppointmentModalBaseCtrl');

var PrivateAppointmentModalCtrl = function(
  $controller,
  $injector,
  $rootScope,
  appointment,
  gettextCatalog,
  modalInstance,
  resources,
) {
  AppointmentModalBaseCtrl.call(this, modalInstance, $injector);
  var self = this;
  var initialEmployeeId = _.get(appointment, 'object._id');
  this.appointment = appointment;
  this.resources = resources;
  this.title = gettextCatalog.getString('Private Appointment');
  this.rootScope = $rootScope;
  this.unlinkedCount = 0;
  this.unlinkedQuestion = '';

  // set default resource
  if (!initialEmployeeId) {
    this.appointment.object = {
      _id: this.resources.employees[0]._id,
    };
  }

  this.recurringSettingsWatcher = this.watchRecurringSettings();

  if (self.appointment.type !== 'private') return;

  if (!self.appointment.externUID && !self.appointment.googleEvent) return;

  var isGoogle = self.appointment.source === 'google';
  var targetID = isGoogle ? self.appointment.office : self.appointment.object._id;
  var getUnlinked = isGoogle
    ? self._AppointmentDA.getGoogleSyncedAndUnlinked
    : self._AppointmentDA.getSyncedAndUnlinked;

  getUnlinked(targetID).then(function(response) {
    if (!response.success || !response.unlinkedAppointments) return;

    self.unlinkedCount = response.unlinkedAppointments;

    if (self.unlinkedCount > 1) {
      self.unlinkedQuestion = gettextCatalog.getString(
        'You have {{count}} unlinked appointments. Do you want to remove them now?',
        { count: self.unlinkedCount },
      );
    } else {
      self.unlinkedQuestion = gettextCatalog.getString(
        'You have one unlinked appointment. Do you want to remove it now?',
      );
    }
  });
};

PrivateAppointmentModalCtrl.prototype = new AppointmentModalBaseCtrl();

module.exports = PrivateAppointmentModalCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/calendar/PrivateAppointmentModalCtrl.js